<ng-template #accountDetails [appCtrlTemplate]="'fgb-edit-account-details'">
  <fgb-edit-account-details [autoEditMode]="true" 
                            (actionDone)="confirmAction$.next($event)"
    ></fgb-edit-account-details>
</ng-template>